var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.448 0.448 0 1 0H19C19.552 0 20 0.448 20 1C20 1.552 19.552 2 19 2H1C0.448 2 0 1.552 0 1ZM19 6H1C0.448 6 0 6.448 0 7C0 7.552 0.448 8 1 8H19C19.552 8 20 7.552 20 7C20 6.448 19.552 6 19 6ZM19 12H1C0.448 12 0 12.448 0 13C0 13.552 0.448 14 1 14H19C19.552 14 20 13.552 20 13C20 12.448 19.552 12 19 12Z",
    fill: "#EFEFFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2645fc52deb9d24d4de726bedf3a2b80.svg";
export { ForwardRef as ReactComponent };